import React, { Component } from 'react'
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import utils from '../utils'

class LazyImg extends Component {
    constructor(props) {
        super(props);

        this.state = { image: { src: null } }
    }

    evaluateImage() {
        if (this.props.img.src === this.state.image.url) return; /* to keep from update overflow @jkr */
        if (!this.props.img.src) return; /* use most recent image @jkr */

        // localStorage.removeItem(this.props.img.src); /* clears cache for the screen @jkr */
        const cache = JSON.parse(localStorage.getItem(this.props.img.src));

        if (!cache || cache.timestamp < Date.now() - utils.time1wk) {
            // console.log("downloading new image...", this.props.img.src);
            fetch(this.props.img.src, {
                headers: utils.credHeaders(),
            })
                .then(response => {
                    // console.log(response)
                    return response.blob()
                })
                .then(blob => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const imgResult = reader.result;
                        try {
                            localStorage.setItem(this.props.img.src, JSON.stringify({ timestamp: Date.now(), image: { url: this.props.img.src, src: imgResult } }));
                            // console.log(reader)
                            this.setState({ image: { url: this.props.img.src, src: imgResult } });
                        } catch (err) {
                            console.warn(err)
                            console.log("resetting localstorage cache!");
                            localStorage.clear();
                            this.setState(this.state);
                        }
                    }
                    reader.readAsDataURL(blob);

                })
                .catch(err => {
                    console.warn(err)
                })
        }
        else if (cache) {
            // console.log("using cached image: ", cache);
            this.setState({ image: cache.image });
        }
    }

    componentDidUpdate() {
        this.evaluateImage();
    }

    componentDidMount() {
        this.evaluateImage();
    }

    render() {
        return (
            <div className="screen-bg-container">
                <div className={"screen-bg"} style={{ backgroundImage: `url(${this.state.image.src})` }} ></div>
                {/* <div className={"screen-bg"} style={{ backgroundImage: `url(${this.state.prevImage.src})` }} ></div> */}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return { _store: state };
};

export default withRouter(connect(mapStateToProps)(LazyImg));